import editRate from '@/core/components/editRate'
import editMaterial from '@/core/components/editMaterial'
// import Bus from '../../assets/js/eventBus'
// import { List } from 'ant-design-vue'
import NP from 'number-precision'
import vue from 'vue'
import store from '../../store'
// import { delay } from 'lodash'
const that = vue.prototype
export default {
  // 原材料管理
  className: 'rawMaterial',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '名称不可为空'
      ]
    },
    {
      name: 'price',
      validators: [
        (val) => val ? null : '单价不可为空',
        (val) => {
          if (val <= 0) {
            return '请输入正确的单价'
          }
        }
      ]
    },
    {
      name: 'rate',
      edit: {
        component: editRate
      },
      validators: [
        (val) => val ? null : '费率不可为空',
        (val) => {
          if (val <= 0) {
            return '请输入正确的费率'
          }
        }
      ]
    },
    'describe'
  ],
  search: [
    'name'
  ],
  action: {
    create: store.state.user && store.state.user.authority.rawMaterial.create
      ? {} : false,
    edit: store.state.user && store.state.user.authority.rawMaterial.edit ? {
      type: 'row',
      text: '编辑',
      title: '编辑',
      component: editMaterial
    } : false,
    delete: store.state.user && store.state.user.authority.rawMaterial.del ? {} : false
    // myDelete: store.state.user && store.state.user.authority.rawMaterial.del
    //   ? {
    //     type: 'row',
    //     text: '删除',
    //     title: '删除',
    //     component: deleteMaterial
    //   } : false
  },
  hooks: {
    async beforeInsert ({ data }) {
      const { data: res } = await that.$tkParse.get('/classes/rawMaterial', {
        params: {
          where: {
            name: data.name
          }
        }
      })
      if (res.results.length > 0) {
        throw that.$notification.error({
          message: '保存失败',
          description: '原材料名称已存在，请修改名称'
        })
      }
    },
    async beforeUpdate ({ objectId, data }) {
      let res = await that.$modelAjax.getData('rawMaterial', {
        params: {
          where: { objectId: objectId }
        }
      })
      let r = res.results[0]
      // 原材料内容改变，修改相应半成品
      if (r.name !== data.name || r.price !== data.price || r.rate !== data.rate) {
        let p = await that.$modelAjax.getData('parts', {
          params: {
            where: { rawMaterialId: { $all: [objectId] } }
          }
        })
        if (p.results.length) {
          p.results.forEach((e) => {
            let total = 0
            e.formula.forEach((el) => {
              if (el.rawMaterial.objectId === objectId) {
                el.rawMaterial.name = data.name
                el.rawMaterial.rate = data.rate
                el.rawMaterial.price = data.price
                el.price = NP.times(el.rawMaterial.price, el.rawMaterial.rate, el.weight, 0.001, 0.01)
                total = NP.plus(total, el.price)
              } else {
                total = NP.plus(total, el.price)
              }
            })
            e.price = total
            that.$modelAjax.put('parts', e.objectId, e).catch(e => {
              throw that.$notification['error']({
                message: '保存失败',
                description: '修改相应半成品失败，请重新尝试'
              })
            })
          })
        }
      }
    },

    async beforeDelete ({ objectId }) {
      // 删除原材料，修改相应半成品和成品
      // 获得修改原材料之前的公布价
      let oriPriceGroup = []
      let priceLog = []
      let { data: a } = await that.$tkParse.post('/totalPrice', objectId)
      oriPriceGroup = a
      console.log('与此材料有关的成品信息', a)
      let { data: p } = await that.$tkParse.get('/classes/parts', {
        params: {
          where: { rawMaterialId: { $all: [objectId] } }
        }
      })

      let { data: f } = await that.$tkParse.get('/classes/finishProduct', {
        params: {
          where: { rawMaterialId: { $all: [objectId] } }
        }
      })

      if (p.results.length) {
        p.results.forEach(async (f) => {
          let rawMaterialId = f.rawMaterialId.filter((fl) => { return fl !== objectId })
          let formula = f.formula.filter((fl) => { return fl.rawMaterial.objectId !== objectId })
          let total = 0
          formula.forEach((fl) => { total = NP.plus(total, fl.price) })
          await that.$modelAjax.put('parts', f.objectId, {
            rawMaterialId: rawMaterialId,
            formula: formula,
            price: total
          }).catch(e => {
            throw that.$notification['error']({
              message: '保存失败',
              description: '修改相应半成品失败，请重新尝试'
            })
          })
        })
      }

      if (f.results.length) {
        await f.results.forEach((g) => {
          let rawMaterialId = g.rawMaterialId.filter((gl) => { return gl !== objectId })
          let formula = g.formula.filter((gl) => { return gl.parts || gl.rawMaterial !== objectId })
          that.$modelAjax.put('finishProduct', g.objectId, {
            rawMaterialId: rawMaterialId,
            formula: formula
          }).catch(e => {
            throw that.$notification['error']({
              message: '保存失败',
              description: '修改相应成品失败，请重新尝试'
            })
          })
          // try {
          //   that.$modelAjax.put('finishProduct', g.objectId, {
          //     rawMaterialId: rawMaterialId,
          //     formula: formula
          //   })
          // } catch (e) {
          //   that.$notification.error({
          //     message: '保存失败',
          //     description: '修改相应成品失败，请重新尝试'
          //   })
          // }
        })
      }
      for (let i in oriPriceGroup) {
        let { data: b } = await that.$tkParse.post('/totalPrice/totalPrice', oriPriceGroup[i].objectId)
        let log = {
          type: '',
          name: oriPriceGroup[i].name,
          user: store.state.user.name,
          reason: 'materialDeleted',
          describe: '由' + oriPriceGroup[i].price + '变为' + b
        }
        if (oriPriceGroup[i].isBatching) {
          log.type = 'batchingFinishProduct'
        } else {
          log.type = 'finishProduct'
        }
        if (oriPriceGroup[i].price !== b) { priceLog.push(log) }
      }

      that.$tkParse.post('/implicitMaterial/delMaterial', objectId).catch(e => { console.log(e) })
      that.$tkParse.post('/totalPrice/toPriceLog', priceLog)
    }
  }
}
